'use client';

import * as React from 'react';

import { ICourseData } from '../../types/course-data';
import { generateCourseColorScheme } from '../../utils/colors';
import { CourseCard } from './course-card';
import { useDashboardStore } from '../../store/dashboard-store';

interface CardWithModalProps extends ICourseData {
  blockOpen?: boolean;
  hasModal?: boolean;
  onCardClickCallback?: (item: ICourseData) => void;
}

const CardWithModal: React.FC<CardWithModalProps> = ({
  blockOpen,
  hasModal = false,
  onCardClickCallback,
  ...courseData
}) => {
  const setDashboardModal = useDashboardStore((state) => state.setDashboardModal);

  const [hasMoved, setHasMoved] = React.useState(false);
  const startPos = React.useRef<{ x: number; y: number }>({ x: 0, y: 0 });

  const handlePointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    startPos.current = { x: e.clientX, y: e.clientY };
    setHasMoved(false);
  };

  const handlePointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    const dx = Math.abs(e.clientX - startPos.current.x);
    const dy = Math.abs(e.clientY - startPos.current.y);
    if (dx > 5 || dy > 5) {
      setHasMoved(true);
    }
  };

  const handlePointerUp = () => {
    if (!hasModal && !!onCardClickCallback && !hasMoved) {
      onCardClickCallback(courseData);
      return;
    }
    if (!blockOpen && !hasMoved) {
      setDashboardModal({ data: courseData, type: courseData.courseType });
    }
  };

  const colorScheme = generateCourseColorScheme(courseData.highlighted, courseData.courseType);
  return (
    <>
      <CourseCard
        {...courseData}
        colorScheme={colorScheme}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
      />
    </>
  );
};

export default CardWithModal;
